module.exports = "/_next/static/images/hero-image-619a632783273909b9fba95d08437f3b.png";